import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { UnassignedTagType } from '@/types/events/unassign-tag';

export default function unassignedTag(data: UnassignedTagType): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.updateOrInsertConversation(data.conversationData);
  conversationsStore.addNewCacheMessage(data.logMessage);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
    conversationsStore.addNewMessage(data.logMessage);
  }
}
